<template>
    <div class="base-page-container">
        <img class="base-page-pic" :src="pic" />
        <div class="base-page-title" v-if="title">{{ title }}</div>
        <div class="base-page-content" v-if="contentList && contentList.length">
            <div
                class="base-page-content-item"
                v-for="(item, index) in contentList"
                :key="index"
            >
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'base-page',
    props: {
        pic: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: [Array, String],
            default: '',
        },
    },
    computed: {
        contentList() {
            return Array.isArray(this.content) ? this.content : this.content && [this.content];
        },
    },
};
</script>

<style lang="less" scoped>
@import '../../assets/style/mixin.less';
.base-page-container {
    padding-top: 160 * @vw;
    .base-page-pic {
        display: block;
        margin-left: 146 * @vw;
        margin-bottom: 24 * @vw;
        width: 159 * @vw;
        height: 122 * @vw;
    }
    .base-page-title {
        margin-bottom: 10 * @vw;
        font-size: 18 * @vw;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        color: #222222;
        line-height: 22 * @vw;
    }
    .base-page-content {
        font-size: 16 * @vw;
        font-family: PingFangSC, PingFangSC-Regular;
        text-align: center;
        color: #666666;
        line-height: 20 * @vw;
        .base-page-content-item {
            margin-bottom: 8 * @vw;
        }
    }
}
</style>
